import React from "react";
import { ClientsManagementProvider } from "../../contexts/ClientsManagementContext";
import ClientsListContent from "./ClientsListContent";

const ClientsList: React.FC = () => {
  return (
    <ClientsManagementProvider>
      <ClientsListContent />
    </ClientsManagementProvider>
  );
};

export default ClientsList;
